import { throttle } from 'lodash'

/**
 * スクロールで閾値を超えた事を検知します
 *
 * @param {function, object} value 関数はハンドラー
 * @param {function} value.handler 閾値を超えた場合のハンドラー
 * @param {number} [value.distance = 0] 閾値とする下からの距離(px)
 * @param {number} [value.delay = 200] チェック間隔(ms)
 */
export default {
  bind(el, { value }) {
    if (!value) return
    const handler = value.handler || value
    const distance = value.distance || 0

    el.$scrollOver = throttle(e => {
      const scrollTop = el.scrollTop
      const threshold = el.scrollHeight - el.clientHeight - distance
      if (threshold <= scrollTop) handler(e)
    }, value.delay || 200)

    el.addEventListener('scroll', el.$scrollOver)
  },
  unbind(el) {
    el.removeEventListener('scroll', el.$scrollOver)
    el.$scrollOver = null
  },
}
